import { createClient } from '@supabase/supabase-js'

// Credenciales via env vars con fallback al valor actual para no romper
// entornos existentes. Defina en Vercel / .env.local:
//   REACT_APP_SUPABASE_URL
//   REACT_APP_SUPABASE_ANON_KEY
// La anon key es pública por diseño (se usa desde el browser + RLS),
// pero manejarla via env permite rotar entre staging/prod sin tocar código.

const DEFAULT_URL = 'https://jhexfffdhktpgtaheehp.supabase.co'
const DEFAULT_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpoZXhmZmZkaGt0cGd0YWhlZWhwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU5NTA3MjIsImV4cCI6MjA5MTUyNjcyMn0.pzsmVl8VIji_hv6SU5LPR3WF2C00UwBY9m7RSkUs8b4'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || DEFAULT_URL
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || DEFAULT_ANON

// Sprint 15.29 — fix magic link callback.
// El default flowType de @supabase/supabase-js v2.x es 'pkce' (intercambio
// con ?code=...&code_verifier). El admin.auth.generateLink() del backend
// genera magic links en flow IMPLICIT (con #access_token=... en hash).
// Si no forzamos 'implicit' acá, el client ignora el hash del callback
// y nunca crea la sesión — el usuario aterriza en /, ve el Login normal
// y no entiende qué pasó. Pasó con Claudio el 2026-05-19 (cliente piloto).
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    flowType: 'implicit',
    detectSessionInUrl: true,
    autoRefreshToken: true,
    persistSession: true,
  },
})
